import _ from 'lodash';
import { useState } from 'react'

const useForm = (callback, data) => {
  const [values, setValues] = useState(data)
  const [orgvalues, setOrgValues] = useState(data)

  const setInitialValuesArray = (array) => {
    array.forEach(element => {
      setInitialValues(element);
    });
} 

  const setInitialValues = (data) => {
    for (var key of Object.keys(data)) {
        //console.log("Key: "+key+", Value: "+data[key]);
        setInitialValue(key, data[key]);
    }
}  
const setInitialValue = (name, value) => {
    setValues(values => ({
      ...values,
      [name]: value
    }))
    setOrgValues(values => ({
      ...values,
      [name]: value
    }))
}

const isDirty = (name) => {
  return values[name]!==orgvalues[name];
}

  const helperText = (name) => {
    if(values[name]!==orgvalues[name] && orgvalues[name]!==''){
        return 'Org value: '+orgvalues[name];
    }
  }

/*   const remove = (path, index) => {
    console.log("Remove path: "+path);
    console.log(_.pullAt(values, path)); TODO fixa att ta bort marks i en array, kanske att metoden kan hantera själv om det är en array eller ett objekt
    setValues(values => ({
      ...values
    }));
  } */

  const handleChange = (event, type) => {
    if(event.persist) event.persist();
    let value = null;
    switch(type)
    {
      case 'Boolean':
        value = event.target.checked?true:false;
        break;
      case 'Int32':
          value = parseInt(event.target.value);
          break;
      default:
        value = event.target.value;
    }
    //console.log("Set path: "+event.target.name);
    _.set(values, event.target.name, value);
    setValues(values => ({
      ...values
    }));
    // Possibly add modified timestamp to see if data is "dirty"
    // _modified: new Date()

/*     setValues(values => ({
      ...values,
      [event.target.name]: value
    })) */
  }

  const handleSubmit = (event, onSubmit) => {
    event.preventDefault()
    callback(values, orgvalues)
  }

  return {
    handleChange,
    handleSubmit,
    setInitialValue,
    setInitialValues,
    orgvalues,
    setInitialValuesArray,
    values,
    setValues,
    helperText,
    isDirty
  }
}

export { useForm }